import { strings } from '@/services/translation/strings';
import { FC } from 'react';
import { RequestStatus } from './RequestsTable.types';

const statusChipStyles: Record<RequestStatus, string> = {
  [RequestStatus.Approved]: 'bg-green-600 text-white',
  [RequestStatus.Denied]: 'bg-red-600 text-white',
  [RequestStatus.Pending]: 'bg-gray-200 text-gray-800',
  [RequestStatus.CancelledByEmployee]: 'bg-gray-200 text-gray-800',
  [RequestStatus.CancelledByManager]: 'bg-gray-200 text-gray-800'
};

export const statusLabels: Record<RequestStatus, string> = {
  [RequestStatus.Approved]: strings.common.approved,
  [RequestStatus.Denied]: strings.common.denied,
  [RequestStatus.Pending]: strings.common.pending,
  [RequestStatus.CancelledByEmployee]: strings.common.cancelledByEmployee,
  [RequestStatus.CancelledByManager]: strings.common.cancelledByManager
};

export const StatusChip: FC<{ status: RequestStatus }> = ({ status }) => (
  <span className={`inline-block rounded-full px-3 py-1 text-xs font-semibold ${statusChipStyles[status]}`}>
    {statusLabels[status]}
  </span>
);
